module.exports = __webpack_public_path__ + "assets/img/face_contrast_example6.e08ea2af.jpeg";